// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "fbf06ca39a07aea8c691327ebd6e99a6c3ec952f/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};